import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { ChangeEmailValues, selectProfileState } from '../user-profile.state'
import { FormGroupState } from 'ngrx-forms'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component'

@Component({
  selector: 'cover-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss'],
})
export class ChangeEmailComponent {
  changeEmailFormState$: Observable<FormGroupState<ChangeEmailValues>>
  currentEmail$: Observable<string>

  constructor(private readonly store: Store, private readonly dialog: MatDialog) {
    this.changeEmailFormState$ = this.store.select(selectProfileState.changeEmailControls)
    this.currentEmail$ = this.store.select(selectProfileState.emailState)
  }

  onSubmit(): void {
    this.dialog.open(ConfirmationDialogComponent)
  }
}
